'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import React, { useId, useMemo } from 'react';
import FormControl from './FormControl';
import FieldsetFormControl from './FieldsetFormControl';
export { default as FullStoryMask, validFullStoryLevels } from './FullStoryMask';
export { default as FormControl } from './FormControl';
export { default as FieldsetFormControl } from './FieldsetFormControl';
export { default as formControlDefaultProps } from './common-default-props';
export { default as Label } from './Label';
export { default as Legend } from './Legend';
export { default as Help } from './Help';
export { default as InputWrapper } from './InputWrapper';
export { default as ValidationIcon } from './ValidationIcon';
export { ErrorMessage, InfoMessage } from './ErrorMessage';
export { default as LabelWithTag } from './LabelWithTag';
export const fieldsetInputTypes = ['RadioGroup', 'CheckboxGroup', 'Radio', 'Checkbox', 'ToggleInput', 'ToggleButton'];
const DecideWhichFormControlToUse = props => {
  const {
    fieldset,
    id: customId,
    children
  } = props;
  const generatedIid = useId();
  const id = useMemo(() => customId || generatedIid, [generatedIid, customId]);
  if (fieldset || children && fieldsetInputTypes.includes(children.type.displayName)) {
    return /*#__PURE__*/_jsx(FieldsetFormControl, {
      ...props,
      id: id
    });
  }
  return /*#__PURE__*/_jsx(FormControl, {
    ...props,
    id: id
  });
};
DecideWhichFormControlToUse.displayName = 'FormControl';
export default DecideWhichFormControlToUse;